import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Tribute from './components/Tribute';
import Contact from './components/Contact';
import './styles/App.css';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Hero />
        <About />
        <Projects />
        <Skills />
        <Tribute />
        <Contact />
      </div>
    </HelmetProvider>
  );
}

export default App;
